import PropTypes from 'prop-types';
import React from 'react';
import entityName from '../../Helpers/EntityName';
import AppService from 'App/legacy/AppService';
import T from 'Components/Helpers/translate';

const propTypes = {
	entity: PropTypes.string.isRequired,
	numSelected: PropTypes.number
};

class GenericBody extends React.Component {
	constructor(props) {
		super(props);
		const { entity, numSelected, fullModalBody, notificationEntityNameExtension } = props;
		const entityText = T(entityName(notificationEntityNameExtension || entity, numSelected)).toLowerCase();
		this.lang = {
			title: this.titleFunction(numSelected, entityText, fullModalBody),
			irreversible: T('admin.modal.actionIrreversible'),
			body: T(numSelected === 1 ? 'admin.modal.genericBodySingle' : 'admin.modal.genericBodyMulti', {
				entity: entityText
			}),
			calendarIntegraionDeleteInfo:
				entity.toLowerCase() === 'appointment' && AppService.getCalendarIntegrations().length
					? T('default.calendarIntegraionDeleteInfo')
					: ''
		};
	}

	render() {
		const { lang } = this;

		return (
			<div className="content-delete-confirm">
				<div className="confirm-body">
					<span className="confirm-warning">{lang.irreversible}</span>
					{lang.body} {lang.calendarIntegraionDeleteInfo}
				</div>
			</div>
		);
	}

	titleFunction(numSelected, entityText, fullModalBody) {
		if (fullModalBody) {
			return T('admin.modal.deleteThisEntity', { entity: entityText });
		} else {
			return (
				T('admin.modal.confirmDeleteAccount') +
				(numSelected === 1 ? entityText : `${numSelected} ${entityText}`)
			);
		}
	}
}

GenericBody.propTypes = propTypes;

export default GenericBody;
